import { mutations } from "./mutations";
import { actions } from "./actions";

const state = {
  AGENT_DATA: {},
  TRANSACTIONS: []
};

export default { state, mutations, actions };
